module.exports = __webpack_public_path__ + "img/vallone-exalt-tooltips-configurator-03.5ede84ba.jpg";